import { App } from "vue";
import { svgSpritePlugin } from "vue-svg-sprite";

export function initSvgSprite(app: App<Element>) {
	app.use(svgSpritePlugin, { url: "/media/svg/common_svgs.svg" });
}
